//functional imports
import React, { useState } from 'react';
//custom componets
//main css
import '../App.css';
//static files



const Footer = ({ children }) => {

    //component view
    return (
        <footer style={{ display: 'flex',  justifyContent:'center', alignItems:'center', color: 'white', fontSize: "14px", marginTop:"100px", textAlign:'center' }}>
                    {children}
            </footer>
    );

};


//styles
const style = {
}

//export componet
export default Footer;



